import {
  createStyles,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  withStyles,
} from '@material-ui/core';
import { Box } from 'app/components/basic/Wrappers/Box';
import { Check } from 'app/components/BasicInputs/Check';
import React from 'react';
import { Entity } from 'types/common';
import { NamePicker } from '../NamePicker';

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    root: {
      height: '100%',
      overflowX: 'auto',
      overflowY: 'auto',
    },
    headerRow: {
      height: 56,
    },
    tableRow: {
      height: 40,
    },
  }),
);

const StyledTableRow = withStyles(theme => ({
  root: {
    height: 40,
  },
}))(TableRow);

export interface HeaderColumnProps {
  checked: boolean;
  name: string;
  cn: number;
  onChange: (value: boolean, cn: number) => void;
}
export function HeaderColumn(props: HeaderColumnProps) {
  const [checked, setChecked] = React.useState<boolean>(props.checked);
  const handleCheckChandge = React.useCallback(
    (value: boolean, cn: number) => {
      setChecked(value);
      props.onChange(value, cn);
    },
    [props],
  );
  return (
    <Box
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Check
        size="small"
        color="primary"
        onChange={(event, value) => {
          handleCheckChandge(value, props.cn);
        }}
        checked={checked}
      />
      <Box
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {props.name}
      </Box>
    </Box>
  );
}
export interface HeaderColumnPickerProps {
  names: Entity<string>[] | undefined;
  value?: Entity<string> | null | undefined;
  cn: number;
  onChange: (value: Entity<string> | null | undefined, cn: number) => void;
}
export function HeaderColumnPicker(props: HeaderColumnPickerProps) {
  const [value, setValue] = React.useState<Entity<string> | null | undefined>(
    props.value,
  );
  const [showPicker, setShowPicker] = React.useState<boolean>(true);
  const handleValueChandge = React.useCallback(
    (value: Entity<string> | null | undefined, cn: number) => {
      setValue(value);
      props.onChange(value, cn);
      if (value !== null) {
        setShowPicker(false);
      }
    },
    [props],
  );
  return (
    <>
      {showPicker ? (
        <NamePicker
          value={value}
          onChange={value => handleValueChandge(value, props.cn)}
          names={props.names}
        />
      ) : (
        <Box
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onClick={() => {
            setShowPicker(true);
          }}
        >
          {value?.Name}
        </Box>
      )}
    </>
  );
}
export interface BasicTableProps {
  header1: JSX.Element[];
  header2: JSX.Element[];
  rows: string[][];
}

export function BasicTable({ header1, header2, rows }: BasicTableProps) {
  const classes = useStyles();
  return (
    <TableContainer className={classes.root}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow className={classes.headerRow}>
            {header1.map(column => (
              <TableCell>{column}</TableCell>
            ))}
          </TableRow>
          {header2.length > 0 && (
            <TableRow className={classes.headerRow}>
              {header2.map(column => (
                <TableCell>{column}</TableCell>
              ))}
            </TableRow>
          )}
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <StyledTableRow key={index}>
              {row.map(cell => (
                <TableCell align="right">{cell}</TableCell>
              ))}
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
